import script from "./DuyuruScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./DuyuruScreen.vue?vue&type=script&setup=true&lang=js"

import "./DuyuruScreen.vue?vue&type=style&index=0&id=559f5fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559f5fc8"]])

export default __exports__